const PromptEndpoints = {
  GET_PROMPTS: (workspaceId: string | null) => `/prompts/?workspace_id=${workspaceId}`,
  UPDATE_PROMPT: (id: string) => `/prompts/${id}/`,
};

export default PromptEndpoints;
